import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import { ref, reactive, watch } from 'vue';
import appConfig from '@/app.config.json'


export default /*@__PURE__*/_defineComponent({
  __name: 'ImgUsuario',
  props: {
    usuarioId: {},
    alt: {}
  },
  setup(__props: any) {

const props = __props

var controle = reactive({
  usuarioId: props.usuarioId,
  erro: false,
  src: props.usuarioId ? `${appConfig.urlApi}/Fotos/Usuarios/${props.usuarioId}.png` : ""
})

watch(() => props.usuarioId, (newVal) => {
  controle.usuarioId = newVal;
  console.log("UsuarioId atualizado:", controle.usuarioId);
  controle.src = controle.usuarioId ? `${appConfig.urlApi}/Fotos/Usuarios/${controle.usuarioId}.png` : "";
}, { immediate: true })


const imgUrl = new URL('@/assets/images/user/sem-imagem-usuario.jpg', import.meta.url).href

function onError(e: Event) {
  const el = e.target as HTMLImageElement;
  controle.erro = true;
  el.src = imgUrl;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _unref(controle).src,
    alt: __props.alt,
    class: "rounded-circle me-2",
    width: "32",
    height: "32",
    style: {"object-fit":"cover"},
    onError: onError
  }, null, 40, _hoisted_1))
}
}

})